import request, { type ApiResponse, type RequestConfig } from '@/utils/request'

export const getClosureRuleOptions = (rule: string, config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.get('/app/activiti/get-comment-type-by-rule', { rule }, config)
}

export const getClosureTodo = (
  processDefinitionKey: string,
  taskDefinitionKey: string,
  config?: RequestConfig,
): Promise<ApiResponse<any>> => {
  return request.post(
    `/app/activiti/todo/${processDefinitionKey}/${taskDefinitionKey}`,
    { processDefinitionKey, taskDefinitionKey },
    config,
  )
}

export const doTaskClosure = (
  action: 'complete' | 'hold' | 'reject' | 'return',
  data: any,
  config?: RequestConfig,
): Promise<ApiResponse<any>> => {
  return request.post(`/app/activiti/doTask-closure/${action}`, [data], config)
}

